import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import {
  scheduledata_setSelectedDay,
  scheduledata_setSelectedWeekNumber,
  scheduledataSelector
} from "reducers/scheduledata/scheduledata";
import { appdataSelector } from "reducers/appdata/appdata";
import { useDispatch, useSelector } from "react-redux";
import enGB from "date-fns/locale/en-GB";

import Cookies from "universal-cookie";
import appdata from "reducers/appdata/appdata";

function Navbar() {
  const dispatch = useDispatch();
  const scheduleData = useSelector(scheduledataSelector);
  const appData = useSelector(appdataSelector);
  const weekdays = [...Array(5).keys()].map(i => enGB.localize.day(i + 1));

  function handleWeekNumberButton(weekNumber) {
    if (weekNumber != scheduleData.selectedWeekNumber) {
      dispatch(scheduledata_setSelectedWeekNumber(weekNumber));
    }
  }

  function handleDayButton(selectedDay) {
    if (selectedDay !== scheduleData.selectedDay) {
      dispatch(scheduledata_setSelectedDay(selectedDay));
    }
  }

  if (!scheduleData) {
    console.log("navbar has no scheduledata");
    return;
  }

  return (
    <React.Fragment>
      {/* weeks */}
      {/* weeks */}
      {/* weeks */}
      {/* weeks */}
      {/* weeks */}
      <ButtonGroup variant="outlined" aria-label="outlined button group">
        <Button
          variant={
            scheduleData.selectedWeekNumber == scheduleData.currentWeekNumber
              ? "contained"
              : "outlined"
          }
          onClick={() => handleWeekNumberButton(scheduleData.currentWeekNumber)}
        >
          This Week ({scheduleData.currentWeekNumber})
        </Button>
        <Button
          variant={
            scheduleData.selectedWeekNumber ==
            scheduleData.currentWeekNumber + 1
            //Test may delete
              ? "contained"
              : "outlined"
          }
          onClick={() =>
            handleWeekNumberButton(scheduleData.currentWeekNumber + 1)
          }
        >
          Next Week ({scheduleData.currentWeekNumber + 1})
        </Button>
      </ButtonGroup>
     
     {/* weekdays */}
     {/* weekdays */}
     {/* weekdays */}
     {/* weekdays */}
     {/* weekdays */}
     {/* weekdays */}
      {appData.appState == "grouporders" && (
        <React.Fragment>
          <br></br>
          <br></br>
          {Object.keys(weekdays).map(key => {
            return (
              <Button
                key={"day" + weekdays[key]}
                variant={
                  scheduleData.selectedDay === key ? "contained" : "outlined"
                }
                onClick={() => handleDayButton(key)}
              >
                {weekdays[key]}
              </Button>
            );
          })}

          <Button
           key={"dayall"}
            variant={
              scheduleData.selectedDay === false ? "contained" : "outlined"
            }
            onClick={() => handleDayButton(false)}
          >
            all
          </Button>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default Navbar;
